import type { UseMutateFunction } from "react-query";
import { t } from "@/i18n-js/instance";
import { Button } from "@circle-react-uikit/Button";
import { Form } from "@circle-react-uikit/Form";
import { Modal } from "@circle-react-uikit/ModalV2";

const REPORT_REASONS = [
  "harassment",
  "spam",
  "incorrect_location",
  "against_guidelines",
  "other",
];

interface ReportModalProps {
  onClose: () => void;
  onReportSubmit: UseMutateFunction<any, unknown, any, unknown>;
  show: boolean;
}

export const ReportModal = ({
  show,
  onClose,
  onReportSubmit,
}: ReportModalProps) => {
  const reportReasonOptions = REPORT_REASONS.map(reason => ({
    value: reason,
    label: t(`flagged_contents.report_reasons.${reason}`),
  }));

  return (
    <Modal
      isOpen={show}
      onClose={onClose}
      title={t("comments.report.form.title")}
    >
      <Modal.Overlay />
      <Modal.Content>
        <Modal.Header>
          <Modal.Title size="sm">{t("comments.report.form.title")}</Modal.Title>
          <Modal.HeaderActions>
            <Modal.CloseButton onClick={onClose} />
          </Modal.HeaderActions>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={formData => onReportSubmit(formData)}>
            <Form.Item
              name="reported_reason_type"
              label={t("flagged_contents.form.reported_reason_type")}
              description={t(
                "flagged_contents.form.reported_reason_type_description",
              )}
              className="!pt-0"
              hideBorder
            >
              <Form.SelectNative
                name="reported_reason_type"
                options={reportReasonOptions}
              />
            </Form.Item>
            <Form.Item
              name="reported_reason_body"
              label={t("flagged_contents.form.reported_reason_body")}
              description={t(
                "flagged_contents.form.reported_reason_body_description",
              )}
              hideBorder
              fullWidth
            >
              <Form.TextArea name="reported_reason_body" />
            </Form.Item>
            <div className="flex justify-end py-4">
              <Button type="submit" variant="primary">
                {t("report")}
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal.Content>
    </Modal>
  );
};
